import { useState, useRef } from "react";
import { Form, Button } from "react-bootstrap";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { RiCloseCircleFill } from "react-icons/ri";
import { WaveLoading } from "react-loadingg";

import useAxios from "services/useAxios.tsx";

import logo from "../../assets/images/logo/logo.png";
import toast from "react-hot-toast";

export default function AddBrand({ setUpdater = () => {} }) {
  const { execute: addBrandApi } = useAxios("brand/add_brand");
  const logoInputRef = useRef(null);

  const [add, setAdd] = useState({ text: "", logo: {} });
  const [isLoading, setIsLoading] = useState(false);
  const addBradFunc = async () => {
    if (
      add?.text == ""
      // ||
      // add?.logo?.preview == undefined ||
      // add?.logo?.preview == null
    ) {
      toast.error("عنوان و لوگو برند الزامی است.");
    } else {
      setIsLoading(true);
      await addBrandApi({ title: add?.text, logo: add?.logo?.file }).then(
        (res) => {
          if (res?.status > 0) {
            toast.success(res?.msg);
            setAdd({ text: "", logo: {} });
            setUpdater((prev) => !prev);
          } else {
            toast.error(res?.msg);
          }
        }
      );
      setIsLoading(false);
    }
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setAdd((prev) => ({
          ...prev,
          logo: {
            preview: event.target.result,
            file: selectedFile,
          },
        }));
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setAdd((prev) => ({ ...prev, logo: { preview: null, file: null } }));
    }
  };
  return (
    <div className="mx-auto" style={{ maxWidth: 600 }}>
      <div className="shadow-sm border mx-2 border-opacity-25 rd-16 p-3">
        <h6 className="text-center border-bottom pb-3">افزودن برند</h6>
        <div className="d-flex  align-items-center">
          <div className=" mr-l-16">
            {/* <label className="font-12-600 mr-b-4"> لوگو</label> */}

            <div className="d-flex position-relative border bg-white rd-8 pd-8 wd-76">
              {!add?.logo?.preview ? (
                <MdOutlineModeEditOutline
                  onClick={() => logoInputRef.current.click()}
                  style={{ transform: "translate(-60%,40%)" }}
                  className="ms-1 list-item wh-24 pd-4 rounded-circle color-white bg-primary pointer fs-3 position-absolute end-0 bottom-0 text-secondary"
                />
              ) : (
                <RiCloseCircleFill
                  onClick={() => {
                    setAdd((prev) => ({
                      ...prev,
                      logo: { preview: null, file: null },
                    }));
                    logoInputRef.current.value = "";
                  }}
                  style={{ transform: "translate(-60%,40%)" }}
                  className="ms-1 list-item wh-24 pd-4 rounded-circle color-white bg-warning pointer fs-3 position-absolute end-0 bottom-0 text-secondary"
                />
              )}

              <img
                src={
                  add?.logo?.preview == null
                    ? logo
                    : add?.logo?.preview != null && add?.logo?.preview
                }
                alt="کاور دسته بندی"
                className="wh-60"
                style={{
                  maxWidth: "60px",
                  maxHeight: "60px",
                  objectFit: "contain",
                }}
              />
            </div>

            <input
              type="file"
              accept="image/*"
              ref={logoInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </div>
          <Form.Group className="flex-grow-1">
            <Form.Label className="font-14-600">عنوان برند</Form.Label>
            <Form.Control
              value={add?.text}
              onChange={(e) =>
                setAdd((prev) => ({ ...prev, text: e?.target?.value }))
              }
            />
          </Form.Group>

          <Button
            className="align-self-end mb-1 ms-2 position-relative"
            style={{ width: 120, height: 40 }}
            onClick={() => addBradFunc()}
            disabled={isLoading}
          >
            {isLoading ? <WaveLoading /> : "ثبت"}
          </Button>
        </div>
      </div>
    </div>
  );
}
